// src/App.js
import {
  HashRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";

import "./index.css";

import HomePage from "./pages/HomePage";
import ReservePage from "./pages/ReservePage";
import PayPage from "./pages/PayPage";
import CatuelPage from "./pages/CatuelPage";
import SuccessPage from "./pages/SuccessPage";
import FailurePage from "./pages/FailurePage";
import CompletePayPage from "./pages/CompletePayPage.jsx";

import ScrollToTop from "./ScrollToTop.js";
import { ReserveProvider } from "./context/ReserveContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";


const theme = createTheme({
  palette: {
    primary: { main: "#E5E1D0" },
    secondary: { main: "#357DED" },
    terceary: { main: "#357DED" },
    mp: { main: "#00A3E0" },
    white: { main: "#fff" },
    backg: { main: "#F4FEC1" },
  },
typography: {
  fontFamily: '"Inter", "Montserrat", sans-serif',
},

  breakpoints: {
    values: { xs: 0, sm: 600, md: 960, lg: 1200, xl: 1880 },
  },
});

function AppShell() {
  const location = useLocation();

  // ✅ Si querés ocultarla en pago/resultado, dejalo así.
  // Si la querés SIEMPRE visible, poné shouldHideNavbar = false.
  const hideNavbarOn = new Set([
    "/pay",
    "/success",
    "/failure",
    "/completepay",
  ]);
  const shouldHideNavbar = hideNavbarOn.has(location.pathname);

  return (
    <>
      {!shouldHideNavbar && <Navbar />}

      {/* ✅ espacio arriba para que la navbar fija no tape el contenido */}
      <Box sx={{ pt: shouldHideNavbar ? 0 : { xs: 9, sm: 10 } }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/reserve" element={<ReservePage />} />
          <Route path="/catuel" element={<CatuelPage />} />
          <Route path="/pay" element={<PayPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/completepay" element={<CompletePayPage />} />
          <Route path="/failure" element={<FailurePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        {!shouldHideNavbar && <Footer />}
      </Box>
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HashRouter>
        <ScrollToTop />
        <ReserveProvider propertyId={301676}>
          <AppShell />
        </ReserveProvider>
      </HashRouter>
    </ThemeProvider>
  );
}

export default App;
